import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from "react-redux";
import { ConfigurationReduxContext, useConfigurationDispatch, useConfigurationSelector, } from "../context/ConfigurationReduxContext";
import { EcsDispatchContext } from "../context/EcsDispatchContext";
import { ConfigurationRootStateContext } from "../context/EcsStateContext";
import { getConfigurationRootState } from "../reducers/selectors";
// import { useStoreInstance } from "../store/useStoreInstance";
import { useGlobalStore } from "../store/useGlobalStore";
/**
 * Propagates
 * - dispatch
 * - state
 * the to the contexts
 * @private
 */
function ReduxStateProxy({ children }) {
    const ecsState = useConfigurationSelector(getConfigurationRootState);
    const dispatch = useConfigurationDispatch();
    return (_jsx(EcsDispatchContext.Provider, { value: dispatch, children: _jsx(ConfigurationRootStateContext.Provider, { value: ecsState, children: children }) }));
}
/**
 * Provides the redux store
 * @param props
 * @private
 */
function ReduxStoreProvider({ children, }) {
    const store = useGlobalStore();
    return (_jsx(Provider, { store: store, context: ConfigurationReduxContext, children: children }));
}
/**
 * Provides the redux store and propagates
 * - dispatch
 * - state
 * the to the contexts
 * @category Provider Component
 * @param props
 */
export function ConfigurationStateProvider({ children, }) {
    return (_jsx(ReduxStoreProvider, { children: _jsx(ReduxStateProxy, { children: children }) }));
}
//# sourceMappingURL=ConfigurationStateProvider.js.map